// Rehydrate synchronously from localStorage so a page refresh doesn't flash the
// login screen (and clobber the current URL) before checkAuthStatus() runs.
const jwtExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' && payload.exp * 1000 < Date.now();
  } catch (_) {
    return false; // can't parse -> let the API be the judge, don't force logout
  }
};

const hydrate = () => {
  try {
    const token = localStorage.getItem('streamToken');
    const userString = localStorage.getItem('streamUser');
    if (token && userString && !jwtExpired(token)) {
      return { user: JSON.parse(userString), token, isAuthenticated: true };
    }
    if (token && jwtExpired(token)) {
      localStorage.removeItem('streamToken');
      localStorage.removeItem('streamUser');
    }
  } catch (_) { /* fall through to logged-out */ }
  return { user: null, token: null, isAuthenticated: false };
};

const initialState = {
  ...hydrate(),
  error: null,
  loading: false
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
        loading: false
      };
    
    case 'LOGIN_FAILURE':
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: action.payload,
        loading: false
      };
    
    case 'LOGOUT':
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
        loading: false
      };
    
    case 'SET_USER':
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
        loading: false
      };
    
    default:
      return state;
  }
};

export default AuthReducer;
